import { toast } from "sonner";

// Adjustment totals already merged into received* by the server.
export function adjOf(rec, group, k) {
  if (group === "receivedFund") return (rec?.fundAdjustments || []).reduce((s, a) => s + (Number(a.amounts?.[k]) || 0), 0);
  if (group === "receivedRice" && k === "balVatika") return (rec?.stockAdjustments || []).reduce((s, a) => s + (Number(a.kg) || 0), 0);
  return 0;
}
export const decOf = (group) => (group.endsWith("Rice") ? 3 : 2);
export const round = (v, d) => Number((Number(v) || 0).toFixed(d));
export const GROUPS = ["openingFund", "receivedFund", "openingRice", "receivedRice"];
export const NEG_MSG = "Negative not allowed. Use Adjustment for a negative correction · ସଂଶୋଧନ ପାଇଁ Adjustment ବ୍ୟବହାର କରନ୍ତୁ";
export const blockMinus = (e) => {
  if (e.key === "-" || e.key === "Subtract") { e.preventDefault(); toast.error(NEG_MSG, { id: "fund-neg" }); }
};

// Covers IME/Android keyboards that send text without a usable keydown.
const blockMinusInput = (e) => {
  if (typeof e.data === "string" && e.data.includes("-")) { e.preventDefault(); toast.error(NEG_MSG, { id: "fund-neg" }); }
};
export const noNegProps = { onKeyDown: blockMinus, onBeforeInput: blockMinusInput };

export const AdjNote = ({ rec, group, unit, testId }) => {
  const t = ["balVatika", "primary", "upperPrimary", "highSchool"].reduce((s, k) => s + adjOf(rec, group, k), 0);
  if (!t) return null;
  return <p className="mt-2 text-xs text-ink-700" data-testid={testId}>Adjustments this month: {t > 0 ? "+" : ""}{t.toFixed(decOf(group))} {unit} (not in Received; included in Closing)</p>;
};

